import { FC } from 'react';

import DialogModal from 'components/DialogModal/DialogModal';

interface CouponsToggleDialogProps {
  isOpen: boolean;
  onClose: () => void;
  isCouponsEnabled: boolean;
  isLoading: boolean;
  onConfirm: () => void;
}

const CouponsToggleDialog: FC<CouponsToggleDialogProps> = ({
  isOpen,
  onClose,
  isCouponsEnabled,
  isLoading,
  onConfirm
}) => {
  if (!isOpen) return null;

  const title = isCouponsEnabled ? 'Disable Coupons' : 'Enable Coupons';
  const description = isCouponsEnabled
    ? 'Are you sure you want to disable coupons? Promo codes will no longer be applicable at checkout.'
    : 'Are you sure you want to enable coupons? Promo codes will be applicable at checkout.';

  return (
    <DialogModal
      isOpen={isOpen}
      title={title}
      description={description}
      modalActions={{
        onConfirm: {
          label: isCouponsEnabled ? 'Disable' : 'Enable',
          action: onConfirm,
          disabled: isLoading
        },
        onClose: {
          label: 'Cancel',
          action: onClose,
          variant: 'outline'
        }
      }}
    />
  );
};

export default CouponsToggleDialog;
